import React from 'react';
import  {route}  from './routes';
import {ContactsOutlined, ProjectOutlined,UserOutlined, BookOutlined, ProfileOutlined ,TeamOutlined,MobileOutlined,FileProtectOutlined,BankFilled} from '@ant-design/icons';
export default {
    menus:[
        {
            key:route.dashboard.key,
            title:'Dashboard',
            icon: <BookOutlined />,
            render:true,
            access:true,
            roles:["manager","*"],
            subs:[
                {
                    key:route.dashboard.index,title:'Dashboard',component:'DashBoardIndex'  ,  render:true,roles:["*"]
                },
                {
                    key:route.dashboard.activation,title:'Activation',component:'DashBoardActivation'  ,  render:true,roles:["*"]
                },
                {
                    key:route.dashboard.device_activity,title:'Device Activity',component:'DashBoardActivity'  ,  render:true,roles:["*"]
                },
                {
                    key:route.dashboard.battery_insight,title:'Battery Insight',component:'DashBoardBattery'  ,  render:true,roles:["*"]
                },
                {
                    key:route.dashboard.nfc_insight,title:'Nfc Activity',component:'DashBoardNfc'  ,  render:true,roles:["*"]
                },
            ],
        },
        {
            key:route.loan.key,title:'Device Register',icon:<MobileOutlined />,  render:true,access:true,roles:["admin","manager"],
            subs:[
                    
                    {key:route.loan.create,title:'Create Device',component:'DeviceCreate',  render:true,roles:["admin","manager"]},
            //        {key:route.loan.single,title:'Single Device Manage',component:'LoanSingleUpdate',  render:true,roles:["admin"]},
            //    {key:route.loan.index,title:'Mass Mode',component:'LoanFile',  render:true,roles:["admin"]},
            ]
        },
        {
            key:route.search.key,title:'Device Monitor',icon:<ProfileOutlined />,  render:true,roles:["*"],access:true,
            subs:[
                {key:route.search.device,title:'Find Device',component:'Device',  render:true,roles:["*"]},
                {key:`${route.search.edit_device}:id`,title:'Edit Device',component:'DeviceEdit',  render:false,roles:["*"]},
                {key:route.search.index,title:'Local DB Query',component:'SearchItem',  render:true,roles:["*"]},
                {key:route.search.export,title:'Device Export',component:'DeviceExport',  render:true,roles:["*"]},
                {key:route.search.clear_activation,title:'Device Operation',component:'ClearActivation'  ,  render:true,roles:["*"] },
                //    {key:route.search.single,title:'Single Loan',component:'LoanSingleUpdate',  render:true,roles:["admin"]},
            ]
        },
        {
            key:route.operation.key,title:'Operation',icon:<FileProtectOutlined />,  render:true,access:true,roles:["admin"],
            subs:[
                {key:route.operation.index,title:'Operation Logs',component:'OperationLogs', render:true,roles:["admin"]},
                   
            ]
        },
        {
            key:route.device_finance.key,
            title:'Information',
            icon: <BookOutlined />,
            render:true,
            access:true,
            roles:["admin"],
            subs:[
                {
                    key:route.device_finance.index,title:'Device Info & Test',component:'DeviceFinance'  ,  render:true,roles:["*"]
                },

            ],
        },
        {
            key:route.finance.key,title:'Finance',icon:<BankFilled />,  render:true,access:true,roles:["admin","manager"],
            subs:[
                    
                {key:route.finance.index,title:'Single Device Manage',component:'LoanSingleUpdate',  render:true,roles:["admin"]},
                {key:route.loan.index,title:'Mass Mode',component:'LoanFile',  render:true,roles:["admin"]},
            ]
        },
        {
            key:route.user.key,
            title:'Account',
            icon: <UserOutlined />,
            render:true,
            access:true,
            roles:["*"],
            subs:[
                {
                    key:route.user.index,title:'Account Manage',component:'User'  ,  render:true,roles:["*"]
                },
                {
                    key:route.user.create,title:'Create New Account',component:'UserCreate',  render:true,roles:["manager","admin"]
                },
                {
                    key:`${route.user.edit}:id`,title:'Passwd Reset',component:'PasswdReset',  render:false,roles:["*"]
                },
                {
                    key:`${route.user.bind_group}:id`,title:'Bind Group',component:'BindGroup',  render:false,roles:["manager","admin"]
                },
            ],
        },
        {
            key:route.group.key,
            title:'Group',
            icon:<TeamOutlined />,
            render:true,
            access:true,
            roles:["manager","admin"],
            subs:[
                {
                    key:route.group.index,title:'Group',component:'Group'  ,  render:true,roles:["manager","admin"]
                },
                {
                    key:route.group.create,title:'Create Group',component:'GroupCreate',  render:false,roles:["manager","admin"]
                },
                {
                    key:`${route.group.edit}:id`,title:'Group Edit',component:'GroupEdit',  render:false,roles:["manager","admin"]
                },
                {
                    key:`${route.group.custom}:id`,title:'Group Bind Custom',component:'GroupCustom',  render:false,roles:["admin"]
                },
                {
                    key:`${route.group.role}:id`,title:'Group Bind Role',component:'GroupRole',  render:false,roles:["admin"]
                },
            ],
        },
        {
            key:route.role.key,
            title:'Role',
            icon: <ProjectOutlined />,
            render:true,
            access:true,
            roles:["admin"],
            subs:[
                {
                    key:route.role.index,title:'Role',component:'Role'  ,  render:true,roles:["admin"]
                },
                {
                    key:`${route.role.edit}:id`,title:'Role Edit',component:'RoleEdit',  render:false,roles:["admin"]
                },
                {
                    key:`${route.role.perm}:id`,title:'Role Edit',component:'BindPerm',  render:false,roles:["admin"]
                },
                {
                    key:`${route.role.create}`,title:'Role Create',component:'RoleCreate',  render:false,roles:["admin"]
                },
            ],
        },
        {
            key:route.perm.key,
            title:'Permission',
            icon: <BookOutlined />,
            render:true,
            aceess:true,
            roles:["admin"],
            subs:[
                {
                    key:route.perm.index,title:'Perms',component:'Perm' , render:true,roles:["admin"]
                },
            ],
        },
        {
            key:route.customs.key,
            title:'Custom',
            icon: <ContactsOutlined />,
            render:true,
            access:true,
            roles:["admin","manager"],
            subs:[
                {
                    key:route.customs.index,title:'Custom',component:'Custom'  ,  render:true,roles:["admin","manager"]
                },
                {
                    key:route.customs.create,title:'Custom Create',component:'CustomCreate'  ,  render:false,roles:["admin"]
                },
                {
                    key:`${route.customs.edit}:id`,title:'Custom Edit',component:'CustomEdit'  ,  render:false,roles:["admin"]
                },
                {
                    key:`${route.customs.app}:id`,title:'Custom App',component:'CustomApp'  ,  render:false,roles:["*"]
                },
                
            ],
        },
    ]
};